import './TeamDonations.scss'

import React from 'react'
import {Theme} from '../../Theme'
import {WysiwygType} from '../../../types'
import {number_format} from '../../../util/price'
import {style} from '../../../util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('teamdonations', ['item'])

export type TeamDonationsType = {
	className?: string
	donations: Array<TeamDonationsItemType>
}

export type TeamDonationsItemType = {
	name?: string
	city: string
	price: number
	text?: WysiwygType
}

export const TeamDonations: React.FC<TeamDonationsType> = ({
	className,
	donations
}) => {
	const t = useTranslation().teams.detail.donations
	if (!donations || donations.length === 0) return null

	return (
		<div className={styles().with(className)}>
			<Theme.H5 className={styles('title')} mod="grey">
				{t.title}
			</Theme.H5>
			<div className={styles('donations')}>
				{donations.map((item, i) => (
					<TeamDonationsItem key={i} {...item} />
				))}
			</div>
		</div>
	)
}

const TeamDonationsItem: React.FC<TeamDonationsItemType> = ({
	name,
	city,
	price,
	text
}) => {
	if (!city) return null
	const t = useTranslation().teams.detail.donations.item
	const priceHasDecimals: boolean = price
		? price - Math.floor(price) !== 0
		: false

	return (
		<div className={styles.item()}>
			<div className={styles.item('top')}>
				<p className={styles.item('top-title')}>
					{name && (
						<>
							<b>{name}</b>
							{t.outcity.replace('{{city}}', city)}
						</>
					)}
					{!name && t.somebody + t.outcity.replace('{{city}}', city)}
				</p>
				{price && (
					<p className={styles.item('top-subtitle')}>
						{number_format(price, priceHasDecimals ? 2 : 0, ',', '.') +
							`${t.subtitle}`}
					</p>
				)}
			</div>
			{text && (
				<div className={styles.item('text')}>
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			)}
		</div>
	)
}
